import Swiper, {
  Navigation,
  Pagination,
  EffectFade,
  Autoplay,
  Thumbs,
  Lazy,
} from "swiper";
import anime from "animejs";
import { toLower } from "lodash-es";
// Install modules
Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Thumbs, Lazy]);

export function statSwiper() {
  const stats = document.querySelectorAll(".animated_stats");
  const slides = document.querySelectorAll(".animated-stats__stat");
  const statsWrapper = document.querySelectorAll(".animated_stats__wrapper");

  if (stats) {
    const statSwiper = document.querySelectorAll(".animated_stats");
    if (window.innerWidth < 768) {
      statsWrapper.forEach((wrapper) => {
        wrapper.classList.remove("row");
      });
      slides.forEach((slide) => {
        slide.removeAttribute("data-aos");
        slide.classList.add("swiper-slide");
        slide.classList.remove("col-3");
        slide.classList.remove("col-md-6");
        slide.classList.remove("col-lg-3");
      });
      statSwiper.forEach((element) => {
        let params = JSON.parse(element.dataset.statSwiper);
        console.log(params);
        new Swiper(element, params);
      });
    }
  }

  window.addEventListener("resize", function (event) {
    if (stats) {
      const statSwiper = document.querySelectorAll(".animated_stats");
      if (window.innerWidth < 768) {
        statsWrapper.forEach((wrapper) => {
          wrapper.classList.remove("row");
        });
        slides.forEach((slide) => {
          slide.classList.add("swiper-slide");
          slide.classList.remove("col-3");
          slide.classList.remove("col-md-6");
          slide.classList.remove("col-lg-3");
        });
        statSwiper.forEach((element) => {
          let params = JSON.parse(element.dataset.statSwiper);
          new Swiper(element, params);
        });
      } else {
        statsWrapper.forEach((wrapper) => {
          wrapper.classList.add("row");
        });
        slides.forEach((slide) => {
          slide.classList.remove("swiper-slide");
          slide.classList.add("col-3");
          slide.classList.add("col-md-6");
          slide.classList.add("col-lg-3");
        });
        statSwiper.forEach((element) => {
          let swiper = element.swiper;
          if (swiper) {
            console.log(swiper);
            swiper.destroy(true, true);
          }
        });
      }
    }
  });
}

export function animateStats() {
  const circles = document.querySelectorAll(
    ".animated-stats__stat__inner .metric"
  );

  circles.forEach((circle) => {
    console.log(circle);
    let dials = document.getElementById("stats");
    let chart = circle.querySelector(".chart");
    let min = chart.dataset.min;
    let val = chart.dataset.val;
    let p = chart.dataset.fill;
    let id = circle.id;

    console.log(val);

    addClass(dials, "animate");

    initializeCount(id, val);

    document.removeEventListener('scroll', runAnimatedStats);

  });
}
export function runAnimatedStats() {
  // Get the an HTML element
  var stats = document.querySelectorAll(".animated-stats");

  stats.forEach((stat) => {
    // Get its bounding client rectangle
    let bounding = stat.getBoundingClientRect();

    if (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth) &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight)
    ) {
      animateStats();
    } else {
      //console.log("Not in the viewport. :(");
      return false;
    }
  });

}

function formatThousands(num) {
  var values = num.toString().split(".");
  return (
    values[0].replace(/.(?=(?:.{3})+$)/g, "$&,") +
    (values.length == 2 ? "." + values[1] : "")
  );
}

function initializeCount(id, total) {
  var cont = document.getElementById(id),
  label = cont.querySelector(".total"),
  num = 0,
  inc = 1,
  timer = total;

  label.innerHTML = 0;

  total = parseFloat(total);

  if (total > 10000) {
    inc = 192;
  } else if (total > 1000) {
    inc = 23;
  } else if (total > 100) {
    inc = 3;
  } else if (total % 1 != 0) {
    inc = 3;
  }

  timer = total / inc;

  function updateLabel() {
    num += inc;
    num = Math.round(num * 10) / 10;
    label.innerHTML = formatThousands(num);
    if (num >= total) {
      clearInterval(timeinterval);
      label.innerHTML = formatThousands(total);
    }
  }

  updateLabel();
  var timeinterval = setInterval(updateLabel, 1 / timer);

}

function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
}

function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
}

function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
}
